"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8898],{

/***/ 63047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bp": function() { return /* binding */ CouponAppliedAtom; },
/* harmony export */   "Cs": function() { return /* binding */ PricePlanInfoAtom; },
/* harmony export */   "R9": function() { return /* binding */ SelectedPlanAtom; }
/* harmony export */ });
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65058);

var PricePlanInfoAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(null);
var CouponAppliedAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
var SelectedPlanAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(null);

/***/ }),

/***/ 8898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_ProPlanUpgradeModal; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-portal/dist/index.mjs
var dist = __webpack_require__(78773);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(752);
// EXTERNAL MODULE: ./hooks/queries/pay/usePayPlan.ts
var usePayPlan = __webpack_require__(83646);
// EXTERNAL MODULE: ./state/user/atom.ts
var atom = __webpack_require__(37271);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ./components/User/_components/common/ProPlanUpgradeModal/index.atom.ts
var index_atom = __webpack_require__(63047);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PricePlanList/index.styles.ts


var PlanWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1julzec1"
} : 0)("border-radius:4px;opacity:0.5;outline:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";transition:all ease-in-out 0.3s;&:hover{opacity:1;outline:3px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.skyblue_300;
}, ";}&.is-active{opacity:1;outline:3px solid ", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.skyblue_300;
}, ";}&.is-disabled{background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.zinc_100;
}, ";color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.zinc_400;
}, ";&:hover{opacity:0.5;outline:none;}}" + ( true ? "" : 0));
var PlanTypeButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1julzec0"
} : 0)("padding:8px 32px;border:1px solid ", function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.zinc_200;
}, ";background-color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
}, ";border-radius:999px;color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.black;
}, ";transition:all ease-in-out 0.3s;&.is-active{border:1px solid ", function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.black;
}, ";background-color:", function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.black;
}, ";color:", function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.white;
}, ";}&:hover{border:1px solid ", function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.black;
}, ";background-color:", function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.black;
}, ";color:", function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.white;
}, ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PricePlanList/index.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var PricePlanList = function PricePlanList() {
  var pricePlanInfo = (0,esm_react/* useAtomValue */.Dv)(index_atom/* PricePlanInfoAtom */.Cs);
  var selectedPlan = (0,esm_react/* useAtomValue */.Dv)(index_atom/* SelectedPlanAtom */.R9);

  var _useAtom = (0,esm_react/* useAtom */.KO)(index_atom/* SelectedPlanAtom */.R9),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      selectedPlanItem = _useAtom2[0],
      setSelectedPlanItem = _useAtom2[1];

  var _useState = (0,react.useState)('monthly'),
      planType = _useState[0],
      setPlanType = _useState[1];

  var selectedPricePlanList = (0,react.useMemo)(function () {
    var filteredPricePlanList = pricePlanInfo && pricePlanInfo.filter(function (item) {
      return item.type == planType;
    }).map(function (item) {
      if (item.name === 'Pro Plus') {
        return _objectSpread(_objectSpread({}, item), {}, {
          name: 'Pro +'
        });
      }

      return item;
    });
    return planType === 'yearly' ? filteredPricePlanList === null || filteredPricePlanList === void 0 ? void 0 : filteredPricePlanList.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        price: item.price / 12
      });
    }) : filteredPricePlanList;
  }, [planType, pricePlanInfo, selectedPlan]);

  var generatePlanClassName = function generatePlanClassName(item) {
    if (item.status === 'same' || item.status === 'next') {
      return 'is-disabled';
    }

    return (selectedPlanItem === null || selectedPlanItem === void 0 ? void 0 : selectedPlanItem.id) === item.id ? 'is-active' : '';
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 16,
      direction: "column",
      padding: 16,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        justifyContent: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanTypeButton, {
          type: "button",
          className: planType === 'monthly' ? 'is-active' : '',
          onClick: function onClick(e) {
            e.stopPropagation();
            setPlanType('monthly');
            setSelectedPlanItem(null);
          },
          children: "\uC6D4\uAC04 \uACB0\uC81C"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanTypeButton, {
          type: "button",
          className: planType === 'yearly' ? 'is-active' : '',
          onClick: function onClick(e) {
            e.stopPropagation();
            setPlanType('yearly');
            setSelectedPlanItem(null);
          },
          children: "\uC5F0\uAC04 \uACB0\uC81C"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
        gap: 8,
        direction: "column",
        children: selectedPricePlanList && selectedPricePlanList.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlanWrapper, {
            className: generatePlanClassName(item),
            padding: 16,
            gap: 16,
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            onClick: function onClick(e) {
              e.stopPropagation();

              if (item.status === 'next' || item.status === 'same') {
                return;
              }

              setSelectedPlanItem(item);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "lg-semibold",
              children: item.name
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
              gap: 4,
              direction: "column",
              justifyContent: "center",
              alignItems: "center",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
                variant: "2xl-semibold",
                color: "black",
                children: ["\u20A9 ", item.price.toLocaleString('ko-KR'), " / \uC6D4"]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "sm-medium",
                color: "zinc_400",
                children: "VAT \uBCC4\uB3C4"
              })]
            })]
          }, item.id);
        })
      })]
    })
  });
};

/* harmony default export */ var ProPlanUpgradeModal_PricePlanList = (PricePlanList);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/queries/pay/usePayCouponValidate.ts


function usePayCouponValidate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function usePayCouponValidate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? usePayCouponValidate_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : usePayCouponValidate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getPayCouponValidate = function getPayCouponValidate(_ref) {
  var code = _ref.code;
  return api/* api.get */.h.get('/pay/coupon', {
    params: {
      code: code
    }
  });
};

var usePayCouponValidate = function usePayCouponValidate(options) {
  return (0,useMutation/* useMutation */.D)(getPayCouponValidate, usePayCouponValidate_objectSpread({}, options));
};

/* harmony default export */ var pay_usePayCouponValidate = (usePayCouponValidate);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/constant.ts
var COUPON_LENGTH_LIMIT = 5;
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/CouponInput/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var CouponTriggerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e3hugfp2"
} : 0)("border-radius:4px;&:hover{background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.skyblue_50;
}, ";}" + ( true ? "" : 0));
var CouponContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e3hugfp1"
} : 0)( true ? {
  name: "1vcw9m1",
  styles: "opacity:0;transition:all ease-in-out 0.3s;visibility:hidden;&.is-visible{opacity:1;visibility:visible;}"
} : 0);
var RotateArrowWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3hugfp0"
} : 0)( true ? {
  name: "1j5mqwi",
  styles: "height:fit-content;transition:all ease-in-out 0.3s;&.is-top{rotate:calc(180deg);}"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/CouponInput/index.tsx


function CouponInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CouponInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CouponInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CouponInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CouponInput = function CouponInput() {
  var toast = (0,src/* useToast */.pm)();
  var couponInputRef = (0,react.useRef)(null);
  var setIsCouponApplied = (0,esm_react/* useSetAtom */.b9)(index_atom/* CouponAppliedAtom */.Bp);
  var setPricePlanInfo = (0,esm_react/* useSetAtom */.b9)(index_atom/* PricePlanInfoAtom */.Cs);
  var setSelectedPlan = (0,esm_react/* useSetAtom */.b9)(index_atom/* SelectedPlanAtom */.R9);

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react.useState)(''),
      coupon = _useState2[0],
      setCoupon = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      errorMessage = _useState3[0],
      setErrorMessage = _useState3[1];

  var handlePayPlanStatus = function handlePayPlanStatus(plan) {
    return plan.map(function (item) {
      return CouponInput_objectSpread(CouponInput_objectSpread({}, item), {}, {
        status: 'new'
      });
    });
  };

  var _usePayCouponValidate = pay_usePayCouponValidate({
    onSuccess: function onSuccess(data) {
      setPricePlanInfo(handlePayPlanStatus(data.data.data.plan));
      setIsCouponApplied(true);
      setSelectedPlan(null);
      toast('쿠폰이 성공적으로 적용되었습니다');
    },
    onError: function onError(error) {
      var _error$response, _error$response2, _error$response3;

      setIsCouponApplied(false);
      setErrorMessage('error');

      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404) {
        setErrorMessage('유효하지 않은 쿠폰입니다');
        toast.error('유효하지 않은 쿠폰입니다');
      } else if (((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 400) {
        setErrorMessage('이미 사용한 쿠폰입니다');
        toast.error('이미 사용한 쿠폰입니다');
      } else if (((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 409) {
        setErrorMessage('이미 플랜을 구독중 입니다');
        toast.error('이미 플랜을 구독중 입니다');
      } else {
        setErrorMessage('알 수 없는 에러입니다 세일즈클루팀에 문의해주세요');
      }
    },
    retry: false
  }),
      mutate = _usePayCouponValidate.mutate;

  var handleConfirmButtonClick = function handleConfirmButtonClick() {
    mutate({
      code: coupon.trim()
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 10,
    direction: "column",
    padding: {
      x: 16,
      y: 12
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
      justifyContent: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CouponTriggerWrapper, {
        gap: 8,
        width: "fit-content",
        justifyContent: "center",
        alignItems: "center",
        onClick: function onClick(e) {
          e.stopPropagation();
          setIsOpen(!isOpen);

          if (couponInputRef.current) {
            couponInputRef.current.scrollIntoView();
          }
        },
        padding: {
          x: 12,
          y: 8
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-medium",
          color: "skyblue_400",
          children: "\uCFE0\uD3F0 \uC785\uB825\uD558\uAE30"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RotateArrowWrapper, {
          className: isOpen ? 'is-top' : 'is-down',
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:caret-down",
            size: 17,
            color: "skyblue_400"
          })
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CouponContainer, {
      gap: 8,
      direction: "column",
      width: "100%",
      className: isOpen ? 'is-visible' : '',
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "sm-medium",
        color: "zinc_400",
        children: "\uCFE0\uD3F0\uBC88\uD638"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: couponInputRef,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
          justifyContent: "space-between",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, {
            width: "80%",
            value: coupon,
            isError: errorMessage !== null,
            onFocus: function onFocus() {
              setErrorMessage(null);
            },
            onChange: function onChange(e) {
              setCoupon(e.target.value);
            }
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
            variant: "skyblue_400_fill",
            disabled: coupon.length < COUPON_LENGTH_LIMIT || errorMessage !== null,
            onClick: handleConfirmButtonClick,
            children: "\uD655\uC778"
          })]
        })
      }), errorMessage !== null && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        as: "p",
        color: "cerise_300",
        variant: "sm-regular",
        marginTop: 8,
        role: "alert",
        children: errorMessage
      })]
    })]
  });
};

/* harmony default export */ var ProPlanUpgradeModal_CouponInput = (CouponInput);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(55830);
// EXTERNAL MODULE: ./hooks/usePaypleScripts.tsx
var usePaypleScripts = __webpack_require__(53762);
// EXTERNAL MODULE: ./hooks/usePayplePayment.ts
var usePayplePayment = __webpack_require__(79960);
;// CONCATENATED MODULE: ./hooks/mutations/pay/useDowngradePlan.ts


function useDowngradePlan_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useDowngradePlan_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useDowngradePlan_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useDowngradePlan_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var downgradePlan = function downgradePlan(request) {
  return api/* api.put */.h.put('/pay/cert/downgrade', request);
};

var useDowngradePlan = function useDowngradePlan(options) {
  return (0,useMutation/* useMutation */.D)(downgradePlan, useDowngradePlan_objectSpread({}, options));
};

/* harmony default export */ var pay_useDowngradePlan = (useDowngradePlan);
// EXTERNAL MODULE: ./utils/getUTCDate.ts + 1 modules
var getUTCDate = __webpack_require__(52497);
// EXTERNAL MODULE: ./utils/josa.ts
var josa = __webpack_require__(25642);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/DowngradeModal/index.tsx



 // Plan을 downgrade할 때에 사용되는 Modal




var DowngradeModal = function DowngradeModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      expiredAt = _ref.expiredAt,
      nextPlan = _ref.nextPlan,
      originPlan = _ref.originPlan,
      handleConfirmButtonClick = _ref.handleConfirmButtonClick;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* NoticeModal */.pK, {
    title: "\uD50C\uB79C \uBCC0\uACBD \uC644\uB8CC",
    isOpen: isOpen,
    onOpenChange: function onOpenChange(open) {
      return setIsOpen(open);
    },
    buttonType: "success",
    buttonText: "\uD655\uC778\uD588\uC2B5\uB2C8\uB2E4",
    handleButtonClick: handleConfirmButtonClick,
    zIndex: zIndex/* Z_INDEX.rootModal */.k.rootModal,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 16,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "xl-medium",
        textAlign: "center",
        children: [(0,getUTCDate/* getUTCDate */.E)(expiredAt, 'yearMonthDay3'), "\uBD80\uD130 ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("b", {
          children: [nextPlan, "\uC73C\uB85C \uAD6C\uB3C5 \uC911\uC778 Plan\uC774 \uBCC0\uACBD\uB429\uB2C8\uB2E4"]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "md-medium",
        color: "zinc_500",
        textAlign: "center",
        children: ["\uAD6C\uB3C5 \uC911\uC774\uC2E0 ", (0,josa/* addJosa */.W)(originPlan, '은'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("b", {
          children: [(0,getUTCDate/* getUTCDate */.E)(expiredAt, 'yearMonthDay3'), " \uC804\uAE4C\uC9C0 \uC774\uC6A9\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4."]
        })]
      })]
    })
  });
};

/* harmony default export */ var ProPlanUpgradeModal_DowngradeModal = (DowngradeModal);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PreventUpgradeModal/index.tsx





// yearly 고객은 업그레이드가 안되기 때문에 안내 문구 작성
var PreventUpgradeModal = function PreventUpgradeModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      handleConfirmButtonClick = _ref.handleConfirmButtonClick;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* NoticeModal */.pK, {
    title: "\uD50C\uB79C \uBCC0\uACBD \uC548\uB0B4",
    isOpen: isOpen,
    onOpenChange: function onOpenChange(open) {
      return setIsOpen(open);
    },
    buttonType: "success",
    buttonText: "\uD655\uC778\uD588\uC2B5\uB2C8\uB2E4",
    handleButtonClick: handleConfirmButtonClick,
    zIndex: zIndex/* Z_INDEX.rootModal */.k.rootModal,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 16,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "xl-medium",
        textAlign: "center",
        children: ["\uC5F0\uAC04 \uD50C\uB79C \uC0AC\uC6A9 \uC911 \uD50C\uB79C \uC5C5\uADF8\uB808\uC774\uB4DC\uB294", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uCC44\uB110\uD1A1 \uC0C1\uB2F4\uC744 \uD1B5\uD574\uC11C\uB9CC \uAC00\uB2A5\uD569\uB2C8\uB2E4."]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        variant: "md-medium",
        color: "zinc_500",
        textAlign: "center",
        children: ["\uC6B0\uCE21 \uD558\uB2E8\uC758 \uCC44\uB110\uD1A1\uC744 \uD074\uB9AD\uD558\uC5EC ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), " \uBCC0\uACBD\uD558\uACE0 \uC2F6\uC73C\uC2E0 \uD50C\uB79C\uACFC \uD568\uAED8 \uBA54\uC2DC\uC9C0\uB97C \uB0A8\uACA8\uC8FC\uC2DC\uBA74 ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC2E0\uC18D\uD788 \uCC98\uB9AC\uD574\uB4DC\uB9AC\uB3C4\uB85D \uD558\uACA0\uC2B5\uB2C8\uB2E4."]
      })]
    })
  });
};

/* harmony default export */ var ProPlanUpgradeModal_PreventUpgradeModal = (PreventUpgradeModal);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/UpgradeButton/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var UpgradeButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Button */.zx,  true ? {
  target: "er3wugk0"
} : 0)( true ? {
  name: "a8d8x9",
  styles: "padding:16px;border-radius:9999px"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/UpgradeButton/index.tsx
















// 결제 관련 로직이 모여있는곳
var UpgradeButton = function UpgradeButton(_ref) {
  var _userInfo$subscriptio2;

  var onOpenChange = _ref.onOpenChange;
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  var selectedPlan = (0,esm_react/* useAtomValue */.Dv)(index_atom/* SelectedPlanAtom */.R9);
  var userInfo = (0,esm_react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);

  var _useState = (0,react.useState)(false),
      isDowngradeNoticeModalOpen = _useState[0],
      setIsDowngradeNoticeModalOpen = _useState[1];

  var _useState2 = (0,react.useState)(null),
      downgradeExpiredAt = _useState2[0],
      setDowngradeExpiredAt = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isPreventUpgradeModalOpen = _useState3[0],
      setIsPreventUpgradeModalOpen = _useState3[1];

  var _usePaypleScripts = (0,usePaypleScripts/* default */.Z)(),
      PaypleRelatedScripts = _usePaypleScripts.PaypleRelatedScripts,
      isAllScriptsReady = _usePaypleScripts.isAllScriptsReady;

  var mutate = (0,usePayplePayment/* default */.Z)({
    onOpenChange: onOpenChange,
    selectedPlanId: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id
  });
  var upgradeMutate = (0,usePayplePayment/* default */.Z)({
    onOpenChange: onOpenChange,
    selectedPlanId: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id,
    isChangePlan: true
  });

  var _useDowngradePlan = pay_useDowngradePlan({
    onSuccess: function onSuccess(data) {
      setDowngradeExpiredAt(data.data.data.nextOrderAt);
      setIsDowngradeNoticeModalOpen(true);
    },
    onError: function onError(error) {
      var _error$response, _error$response2, _error$response3;

      if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 400) {
        alert('이미 결제된 플랜입니다');
      } else if (((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 403) {
        alert('권한이 없습니다');
      } else if (((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 404) {
        alert('구독중인 플랜이 없습니다');
      }
    }
  }),
      downgradePlan = _useDowngradePlan.mutate; // case 1. Free plan 유저가 결제하는 경우,
  // payple 모달띄워서 결제 -> pay/cert api 요청


  var handleNewPay = (0,react.useCallback)(function () {
    if (isAllScriptsReady) {
      mutate(undefined);
    }
  }, [isAllScriptsReady, selectedPlan]); // case 2. 기존의 결제 유저가 다운그레이드 일 때는,
  // downgrade api 요청

  var handleDowngradePay = function handleDowngradePay() {
    if (selectedPlan !== null && selectedPlan !== void 0 && selectedPlan.id) {
      downgradePlan({
        planId: selectedPlan.id
      });
      return;
    }

    alert('선택된 plan이 없습니다');
  }; // case 3. 기존의 결제 유저가 업그레이드 일 때는,
  // payple 모달 띄워서 결제 -> pay/upgrade api 요청
  // 단, 연간 유저가 upgrade할 때는 모달 띄워서 막기


  var handleUpgradePay = (0,react.useCallback)(function () {
    upgradeMutate(undefined);
  }, [isAllScriptsReady, selectedPlan]);
  var handlePlanChangeButtonClick = (0,react.useCallback)(function () {
    if (selectedPlan) {
      if (selectedPlan.status === 'new') {
        handleNewPay();
      } else if (selectedPlan.status === 'upgrade') {
        var _userInfo$subscriptio;

        if ((userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio = userInfo.subscriptionPlan) === null || _userInfo$subscriptio === void 0 ? void 0 : _userInfo$subscriptio.type) === 'yearly') {
          setIsPreventUpgradeModalOpen(true);
          return;
        }

        handleUpgradePay();
      } else if (selectedPlan.status === 'downgrade') {
        handleDowngradePay();
      } else {
        alert('이미 적용된 plan입니다');
      }
    }
  }, [isAllScriptsReady, selectedPlan]);

  var handleDowngradeConfirmButtonClick = function handleDowngradeConfirmButtonClick() {
    setIsDowngradeNoticeModalOpen(false);
    onOpenChange(false); //Downgrade modal이 꺼졌을 때 결제 관리 페이지에서 최신 업데이트 된 값을 보여주기 위해 invalidate처리

    queryClient.invalidateQueries({
      queryKey: ['getSubscriptionAndCardInfo']
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaypleRelatedScripts, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
      padding: 16,
      width: "100%",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeButtonWrapper, {
        width: "100%",
        variant: "skyblue_500_fill",
        disabled: selectedPlan === null,
        onClick: handlePlanChangeButtonClick,
        children: "\uD50C\uB79C \uBCC0\uACBD\uD558\uAE30"
      })
    }), isDowngradeNoticeModalOpen && selectedPlan && downgradeExpiredAt && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.subscriptionPlan) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_DowngradeModal, {
      isOpen: isDowngradeNoticeModalOpen,
      setIsOpen: setIsDowngradeNoticeModalOpen,
      nextPlan: selectedPlan.name,
      originPlan: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio2 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio2 === void 0 ? void 0 : _userInfo$subscriptio2.name,
      expiredAt: downgradeExpiredAt,
      handleConfirmButtonClick: handleDowngradeConfirmButtonClick
    }), isPreventUpgradeModalOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_PreventUpgradeModal, {
      isOpen: isPreventUpgradeModalOpen,
      setIsOpen: setIsPreventUpgradeModalOpen,
      handleConfirmButtonClick: function handleConfirmButtonClick() {
        setIsPreventUpgradeModalOpen(false);
        onOpenChange(false);
      }
    })]
  });
};

/* harmony default export */ var ProPlanUpgradeModal_UpgradeButton = (UpgradeButton);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/Content/index.styles.ts


function Content_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var ContentContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1x5jskp1"
} : 0)( true ? {
  name: "umwchj",
  styles: "overflow-y:auto"
} : 0);
var CouponCancelWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1x5jskp0"
} : 0)("border-radius:4px;&:hover{background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.cerise_50;
}, ";cursor:pointer;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/Content/index.tsx















var Content = function Content(_ref) {
  var onOpenChange = _ref.onOpenChange;

  var _useAtom = (0,esm_react/* useAtom */.KO)(index_atom/* CouponAppliedAtom */.Bp),
      _useAtom2 = (0,slicedToArray/* default */.Z)(_useAtom, 2),
      isCouponApplied = _useAtom2[0],
      setCouponApplied = _useAtom2[1];

  var setSelectedPlan = (0,esm_react/* useSetAtom */.b9)(index_atom/* SelectedPlanAtom */.R9);
  var setPricePlanInfo = (0,esm_react/* useSetAtom */.b9)(index_atom/* PricePlanInfoAtom */.Cs);
  var userInfo = (0,esm_react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);

  var _usePayPlan = (0,usePayPlan/* default */.Z)({
    select: function select(data) {
      return data.data.data.plan.sort(function (a, b) {
        return a.price - b.price;
      });
    },
    onSuccess: function onSuccess(data) {
      if (!isCouponApplied) {
        setPricePlanInfo(data);
        setSelectedPlan(null);
      }
    },
    enabled: !isCouponApplied,
    suspense: true
  }),
      refetch = _usePayPlan.refetch,
      data = _usePayPlan.data;

  var handleCancelCoupon = function handleCancelCoupon() {
    setCouponApplied(false);
    setSelectedPlan(null);
    refetch();
  };

  (0,react.useEffect)(function () {
    setSelectedPlan(null);
    setCouponApplied(false);
    return function () {
      setCouponApplied(false);
    };
  }, []);
  (0,react.useEffect)(function () {
    if (!isCouponApplied) {
      refetch();
    }
  }, [isCouponApplied]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentContainer, {
    direction: "column",
    children: [data && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_PricePlanList, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_error_boundary_umd.ErrorBoundary, {
      fallback: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: "\uC5D0\uB7EC \uBC1C\uC0DD"
      }),
      onError: function onError() {
        alert('결제창을 불러오는데 실패하였습니다 잠시 후 다시 시도해주세요');
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_UpgradeButton, {
        onOpenChange: onOpenChange
      })
    }), (userInfo === null || userInfo === void 0 ? void 0 : userInfo.subscriptionPlan.name) === 'Free' ? isCouponApplied ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
      justifyContent: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CouponCancelWrapper, {
        width: "fit-content",
        padding: {
          x: 12,
          y: 8
        },
        onClick: handleCancelCoupon,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-medium",
          color: "cerise_500",
          children: "\uC801\uC6A9\uB41C \uCFE0\uD3F0 \uCDE8\uC18C\uD558\uAE30"
        })
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_CouponInput, {}) : null]
  });
};

/* harmony default export */ var ProPlanUpgradeModal_Content = (Content);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/ModalShell/index.styles.ts



var _templateObject;




var slideLeft = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    transform: translateX(100%);\n  }\n\n  100% {\n    transform: translateX(0%);\n  }\n"])));
var Overlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cbmjtr3"
} : 0)("position:fixed;z-index:", zIndex/* Z_INDEX.planModalDimmer */.k.planModalDimmer, ";top:0;left:0;width:100%;height:100%;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_700;
}, ";opacity:0.25;" + ( true ? "" : 0));
var FlexHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1cbmjtr2"
} : 0)("padding:16px;border-bottom:1px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_200;
}, ";" + ( true ? "" : 0));
var SplitPanel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1cbmjtr1"
} : 0)("position:fixed;z-index:", zIndex/* Z_INDEX.planModalContainer */.k.planModalContainer, ";top:0;right:0;overflow:hidden;width:345px;height:calc(100% - 96px);margin:48px 0;animation:", slideLeft, " 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, ";border-radius:8px 0 0 8px;" + ( true ? "" : 0));
var SplitComparisonArea = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cbmjtr0"
} : 0)("position:fixed;z-index:", zIndex/* Z_INDEX.planModalContents */.k.planModalContents, ";top:0;left:0;display:flex;overflow:hidden;width:calc(100% - 361px);height:100%;flex-direction:column;align-items:center;padding:48px 24px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/ModalShell/index.tsx






/** 우측 슬라이드 패널(플랜 선택) + 좌측 비교표 2단 구성. */
var ModalShell = function ModalShell(_ref) {
  var onOpenChange = _ref.onOpenChange,
      plans = _ref.plans,
      comparison = _ref.comparison;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SplitPanel, {
      direction: "column",
      padding: {
        bottom: 40
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FlexHeader, {
        justifyContent: "space-between",
        alignItems: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "lg-semibold",
          children: "\uD50C\uB79C \uC120\uD0DD"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-medium",
          as: "button",
          onClick: function onClick() {
            onOpenChange(false);
          },
          color: "zinc_400",
          children: "\uB2EB\uAE30"
        })]
      }), plans]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SplitComparisonArea, {
      children: comparison
    })]
  });
};

/* harmony default export */ var ProPlanUpgradeModal_ModalShell = (ModalShell);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PlanFeatureMatrix/FeatureCell/index.tsx



var FeatureCell = function FeatureCell(_ref) {
  var value = _ref.value,
      isHighlighted = _ref.isHighlighted;

  switch (value.kind) {
    case 'included':
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:check-bold",
        size: 17,
        color: isHighlighted ? 'skyblue_600' : 'viridian_500',
        "aria-label": "\uC81C\uACF5"
      });

    case 'partial':
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:triangle",
        size: 15,
        color: isHighlighted ? 'skyblue_600' : 'zinc_400',
        "aria-label": "\uC81C\uD55C\uC801 \uC81C\uACF5"
      });

    case 'excluded':
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:x-bold",
        size: 17,
        color: "zinc_300",
        "aria-label": "\uBBF8\uC81C\uACF5"
      });

    case 'notApplicable':
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "md-regular",
        color: "zinc_300",
        textAlign: "center",
        "aria-label": "\uD574\uB2F9 \uC5C6\uC74C",
        children: "-"
      });

    case 'value':
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "md-semibold",
        color: isHighlighted ? 'skyblue_600' : 'zinc_700',
        textAlign: "center",
        children: value.text
      });
  }
};

/* harmony default export */ var PlanFeatureMatrix_FeatureCell = (FeatureCell);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PlanFeatureMatrix/index.constants.ts
var PLAN_COLUMNS = ['Free', 'Basic', 'Pro', 'Pro +'];
var yes = {
  kind: 'included'
};
var no = {
  kind: 'excluded'
};
var partial = {
  kind: 'partial'
};
var na = {
  kind: 'notApplicable'
};

var val = function val(text) {
  return {
    kind: 'value',
    text: text
  };
};

var TOOLTIP = {
  fileUpdate: ['세일즈클루 링크는 그대로 두고,', '파일만 변경이 가능합니다.'],
  formEmailVerify: ['문의양식 제출 시 이메일 인증을 요구하여', '스팸 제출을 방지합니다.'],
  customLink: ['sclu.io/s/ 뒤의 주소를 원하는 이름으로 바꿔', '기억하기 쉬운 링크로 공유할 수 있어요.'],
  customDomain: ['자료를 보낼 때, sclu.io/ 대신', '커스텀 도메인으로 시작하는 링크를 만들 수 있어요.'],
  campaignQuota: ['발송량은 구독 시작일 기준으로 매월 초기화되며,', '미사용량은 이월되지 않습니다.', '초과 발송은 애드온으로 추가할 수 있습니다.']
};
var PLAN_FEATURE_MATRIX = [{
  id: 'pdf',
  title: 'PDF 추적 및 관리',
  rows: [{
    id: 'pdf-upload-size',
    label: 'PDF 파일 업로드 최대 용량',
    values: {
      Free: val('100MB'),
      Basic: val('100MB'),
      Pro: val('500MB'),
      'Pro +': val('500MB')
    }
  }, {
    id: 'pdf-upload-count',
    label: 'PDF 파일 업로드 개수',
    values: {
      Free: val('최대 3개'),
      Basic: val('최대 10개'),
      Pro: val('무제한'),
      'Pro +': val('무제한')
    }
  }, {
    id: 'pdf-cta-button',
    label: 'PDF 내 CTA 버튼 추가',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-message-box',
    label: 'PDF 내 메시지 박스 추가',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-video',
    label: 'PDF 내 동영상 추가',
    values: {
      Free: val('계정당 1개'),
      Basic: val('PDF당 3개'),
      Pro: val('PDF당 10개'),
      'Pro +': val('무제한')
    }
  }, {
    id: 'pdf-form',
    label: 'PDF 내 문의양식 커스텀',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-form-cover',
    label: '문의양식에 가림막 기능 더하기',
    values: {
      Free: partial,
      Basic: partial,
      Pro: val('고급 설정'),
      'Pro +': val('고급 설정')
    }
  }, {
    id: 'pdf-form-email-verify',
    label: '문의양식 이메일 인증',
    tooltip: TOOLTIP.formEmailVerify,
    values: {
      Free: no,
      Basic: no,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-page-duration',
    label: '페이지별 열람 시간 분석',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-link-click',
    label: '링크 클릭 데이터 추적',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-share-count',
    label: '파일 공유 횟수 추적',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-download-track',
    label: 'PDF 다운로드 여부 추적',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-referrer',
    label: '유입 경로 분석 (검색·소셜·이메일 등)',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-geo',
    label: '열람자 국가·도시 정보',
    values: {
      Free: no,
      Basic: no,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-history-range',
    label: '열람 기록 조회 기간',
    values: {
      Free: val('7일'),
      Basic: val('전체 기간'),
      Pro: val('전체 기간'),
      'Pro +': val('전체 기간')
    }
  }, {
    id: 'pdf-email-alert',
    label: '실시간 이메일 알림',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-zapier',
    label: 'Zapier 연동',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-csv',
    label: 'CSV 다운로드',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-bot-filter',
    label: '봇 탐지 및 필터링',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-slack-alert',
    label: '실시간 슬랙 알림',
    values: {
      Free: no,
      Basic: no,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-file-update',
    label: 'PDF 파일 업데이트 (링크 유지)',
    tooltip: TOOLTIP.fileUpdate,
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-download-block',
    label: 'PDF 다운로드 비허용 설정',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-badge-remove',
    label: '뷰어 내 세일즈클루 배너 제거',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-utm',
    label: 'UTM 추적',
    values: {
      Free: no,
      Basic: no,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-ga-gtm',
    label: 'Google Analytics / GTM 연동',
    values: {
      Free: no,
      Basic: no,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-custom-link',
    label: '커스텀 링크',
    tooltip: TOOLTIP.customLink,
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'pdf-custom-domain',
    label: '커스텀 도메인',
    tooltip: TOOLTIP.customDomain,
    values: {
      Free: no,
      Basic: no,
      Pro: no,
      'Pro +': yes
    }
  }]
}, {
  id: 'link',
  title: '링크 추적 및 관리',
  rows: [{
    id: 'link-count',
    label: '생성 가능한 링크 수',
    values: {
      Free: val('3개'),
      Basic: val('10개'),
      Pro: val('100개'),
      'Pro +': val('1,000개')
    }
  }, {
    id: 'link-history-range',
    label: '열람 기록 조회 기간',
    values: {
      Free: val('7일'),
      Basic: val('전체 기간'),
      Pro: val('전체 기간'),
      'Pro +': val('전체 기간')
    }
  }, {
    id: 'link-referrer',
    label: '유입 경로 분석 (검색·소셜·이메일 등)',
    values: {
      Free: yes,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'link-url-update',
    label: '링크 URL 업데이트',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'link-og-custom',
    label: 'Open Graph 커스텀',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'link-bot-filter',
    label: '봇 탐지 및 필터링',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'link-geo',
    label: '열람자 국가·도시 정보',
    values: {
      Free: no,
      Basic: no,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'link-utm',
    label: 'UTM 추적',
    values: {
      Free: no,
      Basic: no,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'link-custom-link',
    label: '커스텀 링크',
    tooltip: TOOLTIP.customLink,
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'link-custom-domain',
    label: '커스텀 도메인',
    tooltip: TOOLTIP.customDomain,
    values: {
      Free: no,
      Basic: no,
      Pro: no,
      'Pro +': yes
    }
  }]
}, {
  id: 'client',
  title: '고객 관리',
  rows: [{
    id: 'client-count',
    label: '등록 가능한 고객 수',
    values: {
      Free: val('10명'),
      Basic: val('100명'),
      Pro: val('1,000명'),
      'Pro +': val('10,000명')
    }
  }]
}, {
  id: 'campaign',
  title: '이메일 캠페인',
  badge: 'Beta',
  rows: [{
    id: 'campaign-quota',
    label: '기본 발송량',
    tooltip: TOOLTIP.campaignQuota,
    values: {
      Free: na,
      Basic: val('20'),
      Pro: val('50'),
      'Pro +': val('100')
    }
  }, {
    id: 'campaign-sender-verify',
    label: '발신 이메일 인증',
    values: {
      Free: na,
      Basic: val('1개'),
      Pro: val('1개'),
      'Pro +': val('1개')
    }
  }, {
    id: 'campaign-schedule',
    label: '예약 발송',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }, {
    id: 'campaign-tracking',
    label: '전달·오픈·링크 클릭·열람 확인',
    values: {
      Free: no,
      Basic: yes,
      Pro: yes,
      'Pro +': yes
    }
  }]
}];
/**
 * 플랜명을 비교표 열 키로 정규화한다.
 *
 * API는 'Pro Plus'를 내려주고 PricePlanList가 이를 'Pro +'로 바꿔 atom에 넣는다.
 * 비교표가 그 변환에 의존하지 않도록 두 표기를 모두 받는다.
 */

var normalizePlanName = function normalizePlanName(name) {
  var _PLAN_COLUMNS$find;

  if (!name) {
    return null;
  }

  var normalized = name.trim();

  if (normalized === 'Pro Plus' || normalized === 'Pro+') {
    return 'Pro +';
  }

  return (_PLAN_COLUMNS$find = PLAN_COLUMNS.find(function (plan) {
    return plan === normalized;
  })) !== null && _PLAN_COLUMNS$find !== void 0 ? _PLAN_COLUMNS$find : null;
};
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PlanFeatureMatrix/index.styles.ts


function PlanFeatureMatrix_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


/** 카테고리 헤더를 플랜 헤더 바로 아래에 2단으로 고정하기 위해 높이를 공유한다. */

var HEAD_HEIGHT = 56;
/**
 * 스크롤 주체. position: sticky는 가장 가까운 스크롤 조상을 기준으로 하므로
 * 이 컨테이너가 반드시 스크롤을 담당해야 헤더 고정이 동작한다.
 */

var ScrollArea = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ydqrso6"
} : 0)("overflow:auto;width:100%;min-height:0;flex:1;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";border-radius:8px;" + ( true ? "" : 0));
var Table = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("table",  true ? {
  target: "e1ydqrso5"
} : 0)("width:100%;min-width:720px;border-collapse:separate;border-spacing:0;th,td{padding:12px;border-bottom:1px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_200;
}, ";text-align:center;transition:background-color 0.15s ease-in-out;vertical-align:middle;white-space:pre-line;word-break:keep-all;}tbody tr:hover td:not(.is-highlighted),tbody tr:hover th:not(.is-highlighted){background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.zinc_50;
}, ";}.is-highlighted{background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.skyblue_50;
}, ";}" + ( true ? "" : 0));
/** 좌측 기능명 열. 가로 스크롤 시에도 라벨이 보이도록 고정한다. */

var RowHeadCell = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("th",  true ? {
  target: "e1ydqrso4"
} : 0)("position:sticky;z-index:", zIndex/* Z_INDEX.planMatrixStickyColumn */.k.planMatrixStickyColumn, ";left:0;width:40%;min-width:220px;background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, ";text-align:left;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.mediaQuery.tablet;
}, "{min-width:160px;}" + ( true ? "" : 0));
var HeadCell = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("th",  true ? {
  target: "e1ydqrso3"
} : 0)("position:sticky;z-index:", zIndex/* Z_INDEX.planMatrixStickyHeader */.k.planMatrixStickyHeader, ";top:0;width:15%;height:", HEAD_HEIGHT, "px;background-color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
}, ";&.is-highlighted{box-shadow:inset 0 2px 0 ", function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.skyblue_400;
}, ";}" + ( true ? "" : 0));
/** 좌상단 모서리. 세로·가로 양방향으로 고정되므로 가장 위에 온다. */

var HeadCornerCell = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(HeadCell,  true ? {
  target: "e1ydqrso2"
} : 0)("z-index:", zIndex/* Z_INDEX.planMatrixStickyCorner */.k.planMatrixStickyCorner, ";left:0;width:40%;min-width:220px;", function (_ref9) {
  var theme = _ref9.theme;
  return theme.mediaQuery.tablet;
}, "{min-width:160px;}" + ( true ? "" : 0));
/** 카테고리 구분 행. 표가 길어 플랜 헤더 바로 아래에 2단으로 고정한다. */

var CategoryHeadCell = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("th",  true ? {
  target: "e1ydqrso1"
} : 0)("position:sticky;z-index:", zIndex/* Z_INDEX.planMatrixCategoryHeader */.k.planMatrixCategoryHeader, ";top:", HEAD_HEIGHT, "px;left:0;padding:8px 12px;background-color:", function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.zinc_50;
}, ";text-align:left;" + ( true ? "" : 0));
var LabelCell = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ydqrso0"
} : 0)( true ? {
  name: "1j5vobt",
  styles: "display:flex;align-items:center;gap:4px"
} : 0);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PlanFeatureMatrix/FeatureRow/index.tsx








var FeatureRow = function FeatureRow(_ref) {
  var row = _ref.row,
      highlightedPlan = _ref.highlightedPlan;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RowHeadCell, {
      scope: "row",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelCell, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-regular",
          color: "zinc_700",
          children: row.label
        }), row.tooltip && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* IconTooltip */.MC, {
          iconProps: {
            icon: 'ph:question-fill',
            size: 17,
            color: 'zinc_400'
          },
          children: row.tooltip.map(function (line, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
              children: [index > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), line]
            }, line);
          })
        })]
      })
    }), PLAN_COLUMNS.map(function (plan) {
      var isHighlighted = plan === highlightedPlan;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
        className: isHighlighted ? 'is-highlighted' : '',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanFeatureMatrix_FeatureCell, {
          value: row.values[plan],
          isHighlighted: isHighlighted
        })
      }, plan);
    })]
  });
};

/* harmony default export */ var PlanFeatureMatrix_FeatureRow = (FeatureRow);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PlanFeatureMatrix/index.tsx







var PlanFeatureMatrix = function PlanFeatureMatrix(_ref) {
  var highlightedPlan = _ref.highlightedPlan;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollArea, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeadCornerCell, {
            scope: "col",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              color: "zinc_500",
              children: "\uAE30\uB2A5"
            })
          }), PLAN_COLUMNS.map(function (plan) {
            var isHighlighted = plan === highlightedPlan;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeadCell, {
              scope: "col",
              className: isHighlighted ? 'is-highlighted' : '',
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
                gap: 4,
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                  variant: "md-semibold",
                  color: isHighlighted ? 'skyblue_600' : 'black',
                  children: plan
                }), isHighlighted && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Tag */.Vp, {
                  variant: "skyblue_50",
                  textVariant: "sm-medium",
                  children: "\uC120\uD0DD\uD55C \uD50C\uB79C"
                })]
              })
            }, plan);
          })]
        })
      }), PLAN_FEATURE_MATRIX.map(function (category) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tbody", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryHeadCell, {
              scope: "colgroup",
              colSpan: 5,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
                gap: 8,
                alignItems: "center",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                  variant: "md-semibold",
                  color: "zinc_700",
                  children: category.title
                }), category.badge && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Tag */.Vp, {
                  variant: "loyalblue_50",
                  textVariant: "sm-medium",
                  children: category.badge
                })]
              })
            })
          }), category.rows.map(function (row) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanFeatureMatrix_FeatureRow, {
              row: row,
              highlightedPlan: highlightedPlan
            }, row.id);
          })]
        }, category.id);
      })]
    })
  });
};

/* harmony default export */ var ProPlanUpgradeModal_PlanFeatureMatrix = (PlanFeatureMatrix);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PlanComparisonPanel/index.styles.ts


function PlanComparisonPanel_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


/**
 * 세로 중앙 정렬로 높이를 잡지 않는다.
 * 표가 뷰포트보다 길 때 중앙 정렬은 상단을 잘라내고 스크롤로도 되돌아갈 수 없게 만든다.
 * 대신 부모가 준 높이를 그대로 받아 표 안쪽에서만 스크롤시킨다.
 */

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1cjf2bq2"
} : 0)( true ? {
  name: "5o88j1",
  styles: "width:100%;max-width:1032px;min-height:0;flex:1"
} : 0);
var CouponWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1cjf2bq1"
} : 0)( true ? {
  name: "arfe1i",
  styles: "border-radius:8px"
} : 0);
/* min-height: 0이 없으면 flex 자식이 콘텐츠 높이 아래로 줄지 못해 표가 스크롤되지 않는다. */

var MatrixWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e1cjf2bq0"
} : 0)("overflow:hidden;min-height:0;flex:1;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";border-radius:8px;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/PlanComparisonPanel/index.tsx









var PlanComparisonPanel = function PlanComparisonPanel() {
  var selectedPlan = (0,esm_react/* useAtomValue */.Dv)(index_atom/* SelectedPlanAtom */.R9);
  var isCouponApplied = (0,esm_react/* useAtomValue */.Dv)(index_atom/* CouponAppliedAtom */.Bp);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    gap: 16,
    direction: "column",
    width: "100%",
    children: [isCouponApplied && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CouponWrapper, {
      gap: 8,
      width: "100%",
      direction: "column",
      backgroundColor: "viridian_600",
      padding: 32,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "xl-semibold",
        color: "viridian_50",
        children: "\uCFE0\uD3F0\uC744 \uC801\uC6A9\uD558\uC2DC\uBA74 \uD560\uC778\uB41C \uAE08\uC561\uC73C\uB85C \uACB0\uC81C\uB429\uB2C8\uB2E4"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "md-medium",
        color: "viridian_50",
        children: "\uD560\uC778 \uD61C\uD0DD \uC801\uC6A9 \uAE30\uAC04: \uCFE0\uD3F0 \uBC1C\uAE09 \uC2DC \uACE0\uC9C0\uB418\uC5C8\uB358 \uAE30\uAC04\uAE4C\uC9C0"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MatrixWrapper, {
      gap: 16,
      direction: "column",
      padding: 24,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        direction: "column",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "h2",
          variant: "xl-semibold",
          color: "black",
          children: "\uD50C\uB79C\uBCC4 \uAE30\uB2A5 \uBE44\uAD50"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "md-regular",
          color: "zinc_500",
          children: "\uD50C\uB79C\uC744 \uC120\uD0DD\uD558\uBA74 \uD574\uB2F9 \uC5F4\uC774 \uAC15\uC870\uB429\uB2C8\uB2E4."
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_PlanFeatureMatrix, {
        highlightedPlan: normalizePlanName(selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name)
      })]
    })]
  });
};

/* harmony default export */ var ProPlanUpgradeModal_PlanComparisonPanel = (PlanComparisonPanel);
;// CONCATENATED MODULE: ./components/User/_components/common/ProPlanUpgradeModal/index.tsx









var ProPlanUpgradeModal = function ProPlanUpgradeModal(_ref) {
  var onOpenChange = _ref.onOpenChange;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Root */.f, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_ModalShell, {
      onOpenChange: onOpenChange,
      plans: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_error_boundary_umd.ErrorBoundary, {
        fallback: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: "\uD50C\uB79C \uC815\uBCF4\uB97C \uAC00\uC838\uC624\uB294\uB370 \uC2E4\uD328\uD558\uC600\uC2B5\uB2C8\uB2E4"
        }),
        onError: function onError() {
          alert('플랜 정보를 가져오는 데 실패하여 새로고침을 진행합니다');

          if (location) {
            location.reload();
          }
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Suspense, {
          fallback: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
            width: "95%",
            height: "90%"
          }),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_Content, {
            onOpenChange: onOpenChange
          })
        })
      }),
      comparison: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal_PlanComparisonPanel, {})
    })
  });
};

/* harmony default export */ var common_ProPlanUpgradeModal = (ProPlanUpgradeModal);

/***/ }),

/***/ 54388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export createPayAuth */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62350);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var createPayAuth = function createPayAuth(reqeust) {
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.post */ .h.post('/pay/auth', reqeust);
};

var usePayAuth = function usePayAuth(options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)(createPayAuth, _objectSpread({}, options));
};

/* harmony default export */ __webpack_exports__["Z"] = (usePayAuth);

/***/ }),

/***/ 83646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPayPlan */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getPayPlan = function getPayPlan() {
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .h.get('/pay/plan');
};

var usePayPlan = function usePayPlan(options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(['getPayPlan'], function () {
    return getPayPlan();
  }, _objectSpread({}, options));
};

/* harmony default export */ __webpack_exports__["Z"] = (usePayPlan);

/***/ }),

/***/ 62942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getSubScriptionAndCardInfo */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getSubScriptionAndCardInfo = function getSubScriptionAndCardInfo() {
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .h.get('/pay');
};

var useSubscriptionAndCardInfo = function useSubscriptionAndCardInfo(options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(['getSubscriptionAndCardInfo'], function () {
    return getSubScriptionAndCardInfo();
  }, _objectSpread({}, options));
};

/* harmony default export */ __webpack_exports__["Z"] = (useSubscriptionAndCardInfo);

/***/ }),

/***/ 79960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(752);
/* harmony import */ var _hooks_mutations_pay_usePayAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54388);
/* harmony import */ var _state_user_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37271);
/* harmony import */ var _state_pay_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6504);
/* harmony import */ var _components_User_components_common_ProPlanUpgradeModal_index_atom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63047);
/* harmony import */ var _queries_pay_useSubscriptionAndCardInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62942);








var usePayplePayment = function usePayplePayment(_ref) {
  var selectedPlanId = _ref.selectedPlanId,
      repayPlanInfo = _ref.repayPlanInfo,
      onOpenChange = _ref.onOpenChange,
      _ref$isChangePlan = _ref.isChangePlan,
      isChangePlan = _ref$isChangePlan === void 0 ? false : _ref$isChangePlan;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var userInfo = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(_state_user_atom__WEBPACK_IMPORTED_MODULE_2__/* .userInfoAtom */ .w);
  var selectedPlanInfo = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(_components_User_components_common_ProPlanUpgradeModal_index_atom__WEBPACK_IMPORTED_MODULE_4__/* .SelectedPlanAtom */ .R9);
  var setPayplePayResult = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useSetAtom */ .b9)(_state_pay_atoms__WEBPACK_IMPORTED_MODULE_3__/* .payplePayResultAtom */ .Lp);

  var _useSubscriptionAndCa = (0,_queries_pay_useSubscriptionAndCardInfo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    select: function select(data) {
      return data.data.data;
    }
  }),
      subscriptionAndCardInfoData = _useSubscriptionAndCa.data;

  var getResult = function getResult(res) {
    if (res.PCD_PAY_RST === 'close') {
      router.reload();
      return;
    } else if (res.PCD_PAY_RST === 'error') {
      alert('결제중 오류가 발견되었습니다.\n다시 시도해 주세요.');
      router.reload();
      return;
    } else {
      setPayplePayResult(res);
      router.push("".concat(res.PCD_RST_URL, "?planId=").concat(typeof repayPlanInfo !== 'undefined' ? repayPlanInfo.id : selectedPlanId, "&isChangePlan=").concat(isChangePlan));
    }
  };

  var _usePayAuth = (0,_hooks_mutations_pay_usePayAuth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    onSuccess: function onSuccess(data) {
      var _subscriptionAndCardI, _subscriptionAndCardI2;

      var _data$data$data = data.data.data,
          PCD_AUTH_KEY = _data$data$data.PCD_AUTH_KEY,
          return_url = _data$data$data.return_url;

      if (!selectedPlanInfo && !repayPlanInfo) {
        alert('플랜을 선택해주세요.');
        return;
      }

      if (subscriptionAndCardInfoData !== null && subscriptionAndCardInfoData !== void 0 && (_subscriptionAndCardI = subscriptionAndCardInfoData.card) !== null && _subscriptionAndCardI !== void 0 && _subscriptionAndCardI.billingKey && repayPlanInfo) {
        var _request = {
          PCD_PAY_TYPE: 'card',
          PCD_PAY_WORK: 'CERT',
          PCD_CARD_VER: '01',
          PCD_PAY_GOODS: "".concat(repayPlanInfo.name, " ").concat(repayPlanInfo.type === 'monthly' ? '월간' : '연간'),
          PCD_PAY_TOTAL: repayPlanInfo.totalPrice.toString(),
          PCD_RST_URL: '/payments-loading',
          PCD_AUTH_KEY: PCD_AUTH_KEY,
          PCD_PAY_URL: return_url,
          PCD_PAYER_NO: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id.toString(),
          PCD_PAYER_NAME: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
          PCD_PAYER_EMAIL: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
          callbackFunction: getResult,
          PCD_PAYER_ID: subscriptionAndCardInfoData.card.billingKey,
          PCD_SIMPLE_FLAG: 'Y'
        };
        window.PaypleCpayAuthCheck(_request);
        onOpenChange(false);
        return;
      }

      if (!selectedPlanInfo) {
        alert('선택된 Plan이 없습니다');
        return;
      }

      if (subscriptionAndCardInfoData !== null && subscriptionAndCardInfoData !== void 0 && (_subscriptionAndCardI2 = subscriptionAndCardInfoData.card) !== null && _subscriptionAndCardI2 !== void 0 && _subscriptionAndCardI2.billingKey) {
        var _request2 = {
          PCD_PAY_TYPE: 'card',
          PCD_PAY_WORK: 'CERT',
          PCD_CARD_VER: '01',
          PCD_PAY_GOODS: "".concat(selectedPlanInfo.name, " ").concat(selectedPlanInfo.type === 'monthly' ? '월간' : '연간'),
          PCD_PAY_TOTAL: selectedPlanInfo.totalPrice.toString(),
          PCD_RST_URL: '/payments-loading',
          PCD_AUTH_KEY: PCD_AUTH_KEY,
          PCD_PAY_URL: return_url,
          PCD_PAYER_NO: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id.toString(),
          PCD_PAYER_NAME: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
          PCD_PAYER_EMAIL: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
          callbackFunction: getResult,
          PCD_PAYER_ID: subscriptionAndCardInfoData.card.billingKey,
          PCD_SIMPLE_FLAG: 'Y'
        };
        window.PaypleCpayAuthCheck(_request2);
        onOpenChange(false);
        return;
      }

      var request = {
        PCD_PAY_TYPE: 'card',
        PCD_PAY_WORK: 'CERT',
        PCD_CARD_VER: '01',
        PCD_PAY_GOODS: "".concat(selectedPlanInfo.name, " ").concat(selectedPlanInfo.type === 'monthly' ? '월간' : '연간'),
        PCD_PAY_TOTAL: selectedPlanInfo.totalPrice.toString(),
        PCD_RST_URL: '/payments-loading',
        PCD_AUTH_KEY: PCD_AUTH_KEY,
        PCD_PAY_URL: return_url,
        PCD_PAYER_NO: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id.toString(),
        PCD_PAYER_NAME: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
        PCD_PAYER_EMAIL: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
        callbackFunction: getResult
      };
      window.PaypleCpayAuthCheck(request);
      onOpenChange(false);
    }
  }),
      mutate = _usePayAuth.mutate;

  return mutate;
};

/* harmony default export */ __webpack_exports__["Z"] = (usePayplePayment);

/***/ }),

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8529);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(752);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _state_pay_atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6504);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);









var usePaypleScripts = function usePaypleScripts() {
  var _useAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_3__/* .useAtom */ .KO)(_state_pay_atoms__WEBPACK_IMPORTED_MODULE_2__/* .isJQueryScriptLoadedAtom */ .Xk),
      _useAtom2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useAtom, 2),
      isJQueryScriptLoaded = _useAtom2[0],
      setIsJQueryScriptLoaded = _useAtom2[1];

  var _useAtom3 = (0,jotai__WEBPACK_IMPORTED_MODULE_3__/* .useAtom */ .KO)(_state_pay_atoms__WEBPACK_IMPORTED_MODULE_2__/* .isPaypleScriptLoadedAtom */ .NQ),
      _useAtom4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_useAtom3, 2),
      isPaypleScriptLoaded = _useAtom4[0],
      setIsPaypleScriptLoaded = _useAtom4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isJQueryScriptLoaded && isPaypleScriptLoaded) {
      return;
    }

    var interval = setInterval(function () {
      if (typeof window.$ === 'function') {
        setIsJQueryScriptLoaded(true);
      }

      if (typeof window.PaypleCpayAuthCheck === 'function') {
        setIsPaypleScriptLoaded(true);
      }
    }, 500);
    return function () {
      return clearInterval(interval);
    };
  }, [isJQueryScriptLoaded, isPaypleScriptLoaded]);

  var PaypleRelatedScripts = function PaypleRelatedScripts() {
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
        src: "https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"
      }, "jquery"), isJQueryScriptLoaded && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: window.location.origin === 'https://www.salesclue.io' || window.location.origin === 'https://app.salesclue.io' || window.location.origin === 'https://dev.salesclue.io' ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
          src: "https://cpay.payple.kr/js/cpay.payple.1.0.1.js"
        }, "payple") : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_0___default()), {
          src: "https://democpay.payple.kr/js/cpay.payple.1.0.1.js"
        }, "payple")
      })]
    });
  };

  return {
    PaypleRelatedScripts: PaypleRelatedScripts,
    isAllScriptsReady: isJQueryScriptLoaded && isPaypleScriptLoaded
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (usePaypleScripts);

/***/ }),

/***/ 6504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ payplePayResultAtom; },
/* harmony export */   "NQ": function() { return /* binding */ isPaypleScriptLoadedAtom; },
/* harmony export */   "Xk": function() { return /* binding */ isJQueryScriptLoadedAtom; }
/* harmony export */ });
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65058);

var payplePayResultAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(null);
var isJQueryScriptLoadedAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
var isPaypleScriptLoadedAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);

/***/ }),

/***/ 52497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ getUTCDate; }
});

// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/dayjs/locale/ko.js
var ko = __webpack_require__(31605);
// EXTERNAL MODULE: ../../node_modules/dayjs/locale/en.js
var en = __webpack_require__(16017);
// EXTERNAL MODULE: ../../node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(10264);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
;// CONCATENATED MODULE: ./constants/dayjs.ts
var dayjsFormat = {
  "default": 'M월 D일 h:mm A',
  withYear: 'YYYY년 MM월 DD일 hh:mm A',
  yearMonthDay: 'YYYY. MM. DD.',
  yearMonthDay2: 'YYYY.MM.DD',
  yearMonthDay3: 'YYYY년 M월 D일',
  yearMonthDayDayOfTheWeek: 'YYYY. MM. DD. dd',
  hourMinute: 'h:mm A',
  leadingZeriHourMinute: 'HH:mm A',
  yearMonthDayWithMinute: 'YYYY. MM. DD. hh:mm A'
};
;// CONCATENATED MODULE: ./utils/getUTCDate.ts





dayjs_min_default().extend((utc_default()));
var getUTCDate = function getUTCDate() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var format = arguments.length > 1 ? arguments[1] : undefined;

  if (!time && format) {
    return dayjs_min_default().utc().format(dayjsFormat[format]);
  }

  if (!time) {
    return dayjs_min_default().utc().format(dayjsFormat["default"]);
  }

  if (!dayjs_min_default()(time).isValid()) {
    return undefined;
  }

  if (!format) {
    return dayjs_min_default().utc(time).format(dayjsFormat["default"]);
  }

  if (format === 'yearMonthDayDayOfTheWeek') {
    dayjs_min_default().locale('ko');
    return dayjs_min_default().utc(time).format(dayjsFormat.yearMonthDayDayOfTheWeek);
  }

  dayjs_min_default().locale('en');
  return dayjs_min_default().utc(time).format(dayjsFormat[format]);
};

/***/ }),

/***/ 25642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ addJosa; }
/* harmony export */ });
/* unused harmony export getJosa */
var koreanCharCode = {
  start: '가'.charCodeAt(0),
  end: '힣'.charCodeAt(0),
  jongSeongStart: 28
};
var REG_SPECIAL_CHAR = new RegExp("(?:".concat(['[ㄱ-ㄷㅁ-ㅎ036]', '^[mn]', '\\S[mn]e?', '\\S(?:[aeiom]|lu)b', '(?:u|\\S[aei]|[^o]o)p', '(?:[^auh]i|\\Su|[^ei][ae]|[^oi]o)t', '(?:\\S[iou]|[^e][ae])c?k', '\\S[aeiou](?:c|ng)', 'foot|go+d|b[ai]g|private', '^(?:app|kor)'].join('|'), ")$"), 'i');
var josaTable = [{
  reg: /^(을|를)$/,
  map: ['를', '을']
}, {
  reg: /^(이|가)$/,
  map: ['가', '이']
}, {
  reg: /^(은|는)$/,
  map: ['는', '은']
}, {
  reg: /^(이에요|예요)$/,
  map: ['예요', '이에요']
}, {
  reg: /^(과|와)$/,
  map: ['와', '과']
}, {
  reg: /^(으?로)$/,
  map: ['로', '으로'],
  mapper: function mapper(jongseong) {
    var noJongseong = jongseong === 0;

    if (noJongseong) {
      return 0;
    }

    var isLieul = jongseong === 8;

    if (isLieul) {
      return 0;
    }

    return 1;
  }
}, {
  reg: /^(이?)([고나네다라면지])$/,
  map: ['$2', '이$2']
}];

var checkJosaTable = function checkJosaTable(josa, jongseong) {
  var _mapper;

  var item = josaTable.find(function (x) {
    return x.reg.test(josa);
  });

  if (item == null) {
    return undefined;
  }

  var reg = item.reg,
      map = item.map,
      mapper = item.mapper;
  return josa.replace(reg, map[((_mapper = mapper === null || mapper === void 0 ? void 0 : mapper(jongseong)) !== null && _mapper !== void 0 ? _mapper : jongseong) !== 0 ? 1 : 0]);
};

var getJosa = function getJosa() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var josa = arguments.length > 1 ? arguments[1] : undefined;
  var as = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : text;

  if (as == null || as === '') {
    return '';
  }

  var code = as.charCodeAt(as.length - 1);

  if (code < koreanCharCode.start || code > koreanCharCode.end) {
    var hasJongseong = REG_SPECIAL_CHAR.test(text);
    return checkJosaTable(josa, hasJongseong ? -1 : 0);
  }

  var jongseong = (code - 0xac00) % 28;
  return checkJosaTable(josa, jongseong);
};
var addJosa = function addJosa() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var josa = arguments.length > 1 ? arguments[1] : undefined;
  var as = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : text;

  if (as == null || as === '') {
    return '';
  }

  return text + getJosa(text, josa, as);
};

/***/ })

}]);